import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory } from "react-router-dom";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const history = useHistory();
  const username = localStorage.getItem("username");
  // console.log(username);
  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
      {(hasHiddenAuthButtons === "productPage" && !username) && (
        <>
          <Box>{children}</Box>
          <Box>
            <Button
              className="explore-button"
              variant="text"
              onClick={() => {
                history.push("/login");
              }}
            >
              LOGIN
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                history.push("/register" , { from: "header" });
              }}
            >
              REGISTER
            </Button>
          </Box>
        </>
      )}
      {hasHiddenAuthButtons === "registerPage" && (
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => {
            history.push("/");
          }}
        >
          Back to explore
        </Button>
      )}

      {(hasHiddenAuthButtons === "productPage" && username) && (
        <>
         <Box>{children}</Box>
         <Box display="flex" justifyContent="center" align-items="center">
          <img src="avatar.png" alt={username} />
          <p style ={{display:"inline-block", marginTop:"1.1rem"}}>{username}</p>
          <Button
            className="explore-button"
            variant="text"
            onClick={() => {
              localStorage.clear();
              window.location.reload(true);
            }}
          >
            LOGOUT
          </Button>
        </Box>
        </>
       
      )}
      {hasHiddenAuthButtons === "loginPage" && (
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => {
            history.push("/");
          }}
        >
          Back to explore
        </Button>
      )}
    </Box>
  );
};

export default Header;
